import React from 'react';
import { HiOutlineDocumentReport } from 'react-icons/hi';
import styles from './styles/noLayout.module.css';

interface NoReportInterface {
  type: 'REPORT' | 'INVENTORIES' | 'CHECKLISTS' | 'TRACKER';
}

const NoReportLayout: React.FC<NoReportInterface> = ({ type }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.iconContainer}>
        <HiOutlineDocumentReport className={styles.icon} />
      </div>

      <p className={styles.boldCenter}>
        No layout was created for this report type
      </p>
      <p className={styles.subText}>
        Please ask your administrator to create a layout
      </p>
    </div>
  );
};

export default NoReportLayout;
